import { render, staticRenderFns } from "./FilesPopup.vue?vue&type=template&id=74a23d0a&"
import script from "./FilesPopup.vue?vue&type=script&lang=js&"
export * from "./FilesPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports